import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7032a092"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-5" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header border-0 pt-6" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_6 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = {
  class: "d-flex gap-3 justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "svg-icon svg-icon-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  type: "button",
  class: "btn btn-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_15 = { class: "svg-icon svg-icon-2" }
const _hoisted_16 = { class: "me-0" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_19 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_20 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-380px",
  "data-kt-menu": "true"
}
const _hoisted_21 = { class: "menu-item px-3" }
const _hoisted_22 = { class: "menu-content fs-6 text-gray-400 px-3 py-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1))
const _hoisted_24 = { class: "menu-item px-3" }
const _hoisted_25 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_26 = { class: "menu-item px-3" }
const _hoisted_27 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_28 = { class: "menu-item px-3" }
const _hoisted_29 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 opacity-75" }, null, -1))
const _hoisted_31 = { class: "card-body pt-0" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("--")
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "svg-icon svg-icon-2" }
const _hoisted_38 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_FilterDropdwon = _resolveComponent("FilterDropdwon")!
  const _component_index_sub_table = _resolveComponent("index-sub-table")!
  const _component_common_currency = _resolveComponent("common-currency")!
  const _component_MBDatatablePlus = _resolveComponent("MBDatatablePlus")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-14",
              placeholder: _ctx.t('common.search')
            }, null, 40, _hoisted_7), [
              [_vModelText, _ctx.search]
            ]),
            _withDirectives(_createElementVNode("span", {
              class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
            }, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ], 512), [
              [_vShow, _ctx.search != '']
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light-primary",
                  disabled: _ctx.loading || _ctx.disabledExportSelected,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filesExport('selected')))
                }, [
                  _withDirectives(_createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr044.svg" })
                    ])
                  ], 512), [
                    [_vShow, !_ctx.disabledExportSelected && !_ctx.loading]
                  ]),
                  _withDirectives(_createElementVNode("span", null, _hoisted_13, 512), [
                    [_vShow, _ctx.disabledExportSelected || _ctx.loading]
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("common.downloadSelected")) + "(" + _toDisplayString(_ctx.checkedInvoice.length) + ")", 1)
                ], 8, _hoisted_10), [
                  [_vShow, _ctx.checkedInvoice.length != 0]
                ])
              ]),
              _: 1
            }),
            _createElementVNode("button", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
              ]),
              _createTextVNode(_toDisplayString(_ctx.t("common.filter")), 1)
            ]),
            _createVNode(_component_FilterDropdwon, {
              ref: "filterRef",
              onSubmitFilter: _ctx.handleFilter,
              onResetFilter: _ctx.handleFilterReset
            }, null, 8, ["onSubmitFilter", "onResetFilter"]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("button", {
                class: "btn btn-icon btn-bg-light btn-active-color-primary",
                "data-kt-menu-trigger": "click",
                "data-kt-menu-placement": "bottom-end",
                "data-kt-menu-flip": "top-end",
                disabled: 
                  _ctx.loading ||
                  _ctx.disabledExportAll ||
                  _ctx.disabledExportLastWeek ||
                  _ctx.disabledExportLastMonth
                
              }, [
                (
                    _ctx.disabledExportAll ||
                    _ctx.disabledExportLastWeek ||
                    _ctx.disabledExportLastMonth
                  )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                  : (_openBlock(), _createElementBlock("i", _hoisted_19))
              ], 8, _hoisted_17),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.t("common.exportExcel")), 1)
                ]),
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["menu-link px-3", {
                      'opacity-50': _ctx.disabledExportAll,
                      'cursor-nodrop': _ctx.disabledExportAll,
                    }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filesExport('all')))
                  }, [
                    (_ctx.disabledExportAll)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.downloadAll")) + "(" + _toDisplayString(_ctx.total) + ") ", 1)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["menu-link px-3", {
                      'opacity-50': _ctx.disabledExportLastWeek,
                      'cursor-nodrop': _ctx.disabledExportLastWeek,
                    }]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filesExport('lastWeek')))
                  }, [
                    (_ctx.disabledExportLastWeek)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.downloadLastWeek", [
                        _ctx.settlementLastWeekDate({}),
                        _ctx.settlementLastWeekDate({
                          isStart: false,
                        }),
                      ])), 1)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["menu-link px-3", {
                      'opacity-50': _ctx.disabledExportLastMonth,
                      'cursor-nodrop': _ctx.disabledExportLastMonth,
                    }]),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filesExport('lastMonth')))
                  }, [
                    (_ctx.disabledExportLastMonth)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.downloadLastMonth", [
                        _ctx.settlementLastMonthDate({}),
                        _ctx.settlementLastMonthDate({
                          isStart: false,
                        }),
                      ])), 1)
                  ], 2)
                ]),
                _hoisted_30
              ])
            ])), [
              [_directive_auth, { auth: ['export'] }]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_MBDatatablePlus, {
          loading: _ctx.loading,
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          order: "desc",
          "enable-items-per-page-dropdown": true,
          "current-page": _ctx.currentPage,
          total: _ctx.total,
          "rows-per-page": _ctx.pageSize,
          selection: _ctx.isCanExport,
          onSelectChange: _ctx.onRowsSelectChange,
          onCurrentChange: _ctx.onCurrentPageChange,
          onItemsPerPageChange: _ctx.onRowsPerPageChange,
          onSort: _ctx.onColumnSort
        }, {
          "cell-sub": _withCtx(({ row: item }) => [
            _createVNode(_component_index_sub_table, {
              itemData: item,
              tableColspan: _ctx.tableHeader.length
            }, null, 8, ["itemData", "tableColspan"])
          ]),
          "cell-os_invoice_number": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.invoice_number ? item.invoice_number : "--"), 1)
          ]),
          "cell-invoice_amount": _withCtx(({ row: item }) => [
            _createVNode(_component_common_currency, {
              currency: item.currency,
              amount: item.commission_amount
            }, null, 8, ["currency", "amount"])
          ]),
          "cell-paid_amount": _withCtx(({ row: item }) => [
            _createVNode(_component_common_currency, {
              currency: item.currency,
              amount: item.paid_amount
            }, null, 8, ["currency", "amount"])
          ]),
          "cell-dr_invoice_number": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.dr_invoice_number ? item.dr_invoice_number : "--"), 1)
          ]),
          "cell-entity": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.entity ? item.entity : "--"), 1)
          ]),
          "cell-od_number": _withCtx(({ row: item }) => [
            (item.order_number.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.order_number, (sub) => {
                  return (_openBlock(), _createElementBlock("div", { key: sub }, _toDisplayString(sub), 1))
                }), 128))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_32
                ], 64))
          ]),
          "cell-os_invoice_status": _withCtx(({ row: item }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.getOCPSSSReceivablesStatus(item.status)])
            }, _toDisplayString(item.status_label), 3)
          ]),
          "cell-dr_invoice_date": _withCtx(({ row: item }) => [
            (item.invoice_date)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(item.invoice_date ? _ctx.formatDate(item.invoice_date) : "--"), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_34, "--"))
          ]),
          "cell-actions": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_35, [
              (_ctx.isCanExport)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                    onClick: ($event: any) => (_ctx.fileExport(item.id, item))
                  }, [
                    _createElementVNode("span", _hoisted_37, [
                      (!item.downloadDisabled)
                        ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                            key: 0,
                            src: "media/icons/duotune/arrows/arr044.svg"
                          }))
                        : (_openBlock(), _createElementBlock("span", _hoisted_38))
                    ])
                  ], 8, _hoisted_36))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "selection", "onSelectChange", "onCurrentChange", "onItemsPerPageChange", "onSort"])
      ])
    ])
  ]))
}